const common: App.I18n.Schema['translation']['common'] = {
  action: '操作',
  add: '新增',
  addSuccess: '添加成功',
  backToHome: '返回首页',
  batchDelete: '批量删除',
  cancel: '取消',
  check: '勾选',
  close: '关闭',
  columnSetting: '列设置',
  config: '配置',
  confirm: '确认',
  confirmDelete: '确认删除吗？',
  delete: '删除',
  deleteSuccess: '删除成功',
  edit: '编辑',
  error: '错误',
  errorHint: '出错了，请稍后再试',
  expandColumn: '展开列',
  index: '序号',
  keywordSearch: '请输入关键词搜索',
  logout: '退出登录',
  logoutConfirm: '确认退出登录吗？',
  lookForward: '敬请期待',
  modify: '修改',
  modifySuccess: '修改成功',
  noData: '无数据',
  operate: '操作',
  pleaseCheckValue: '请检查输入的值是否合法',
  refresh: '刷新',
  reset: '重置',
  search: '搜索',
  switch: '切换',
  tip: '提示',
  trigger: '触发',
  tryAlign: '刷新重试',
  update: '更新',
  updateSuccess: '更新成功',
  userCenter: '个人中心',
  warning: '警告',
  yesOrNo: {
    no: '否',
    yes: '是'
  }
};

export default common;
